import { request } from "common/components/request";
import { store } from "common/store";
import { getQFilter, toQueryString } from "common/utils";

import { Qualifiers } from "common/components/queryBuilder/qualifiers";

import { actions } from "common/reducers/reconciliation";

const defaultKeys = () => [
    "stl_currency",
    store.getState().reconciliation.transferStatus === "settled" ? "settle_date" : "accepted_date",
    "acquirer",
    "funds_transfer_groupings.merchant_id",
    "funds_transfer_groupings.company_id",
    "funds_transfer_groupings.batch_id",
    "funds_transfer_groupings.bank_statement_narrative"
];

export const FETCH_BATCH_TRANSACTIONS = ({ ...params }) => request("/merchant/:merchant_ref/processor/reconciliation/v3/txns", {
    data: { ...params }
});

export const FETCH_BATCH_SUMMARY = ({ ...params }) => request("/merchant/:merchant_ref/processor/reconciliation/v3", { data: { ...params } });

export const RESET_RECON_STORE = (data = {}) => store.dispatch(actions.RESET_RECON_STORE(data));

export const SET_RECON_STORE = (data = {}) => store.dispatch(actions.SET_RECON_STORE(data));

export const TOGGLE_RECONCILED_STATUS = ({ obj, keys = defaultKeys() } = {}) => {
    const q = getQFilter({ keys, obj });

    if (!q || q === "") throw new Error("empty q string");
    const state = store.getState();
    const query = toQueryString({
        start: state.common.date_range.startDate,
        end: state.common.date_range.endDate,
        status: state.reconciliation.transferStatus,
        section: state.reconciliation.section,
        q
    });

    return request(`/merchant/:merchant_ref/processor/reconciliation/v3?${query}`, {
        method: "POST",
        data: { reconciled: !obj.reconciled }
    });
};

export const TOGGLE_FLAGGED_STATUS = ({ obj, keys = defaultKeys() } = {}) => {
    const q = getQFilter({ keys, obj });

    if (!q || q === "") throw new Error("empty q string");
    const state = store.getState();
    const query = toQueryString({
        start: state.common.date_range.startDate,
        end: state.common.date_range.endDate,
        status: state.reconciliation.transferStatus,
        section: state.reconciliation.section,
        q
    });

    return request(`/merchant/:merchant_ref/processor/reconciliation/v3?${query}`, {
        method: "POST",
        data: { flagged: !obj.flagged }
    });
};

export const SET_SORT_OPTIONS = (data) => store.dispatch(actions.SET_SORT_OPTIONS(data));

export const UPDATE_RECON_QUALIFIERS = (qString, resetCategories = []) => {
    const qualifiers = new Qualifiers({
        value: store.getState().reconciliation.qualifiers
    });

    if (resetCategories) {
        resetCategories.forEach((c) => qualifiers.remove(c));
    }

    qualifiers.addOrReplace(qString);

    store.dispatch(actions.SET_QUALIFIERS(qualifiers.toString(true)));
};
